import React from 'react'
import "./Blog_card.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { Link } from 'react-router-dom'
import { IMG_URL } from '../../../utils/common'
import parse from 'html-react-parser';

function Blog_card({ baseLink, blogData }) {


  return (
    <>
      <Link to={baseLink}>
        <section className='Blog_card'>
          <div className='img_holder'>
            <img
              className="Blog_img"
              src={process.env.REACT_APP_IMG_URL+blogData.image}
              // src={process.env.PUBLIC_URL + imgSrc}
              alt={"Blog_img"}
            />

            <FontAwesomeIcon className='arrow_icon' icon={faArrowRight} />
          </div>
          <div className='text_holder'>
            <h4>{blogData.name}</h4>
            <p>{blogData.subname}</p>
            <p>{parse(blogData?.description)}</p>

          </div>
        </section>
      </Link>
    </>
  )
}

export default Blog_card
